import React from 'react';
import ErrorMsg from './error-msg';

/**
 * Campo reutilizável de CAPTCHA (imagem + input + atualizar + countdown).
 * Integra-se com Formik via props de value/onChange/onBlur/error.
 */
const CaptchaField = ({
  captcha,
  captchaLoading,
  captchaLoadError,
  onRefresh,
  value,
  onChange,
  onBlur,
  error,
  touched,
  secondsLeft = null,
  name = 'captcha',
  id = 'captcha',
}) => {
  const showCountdown =
    typeof secondsLeft === 'number' && secondsLeft > 0 && !captchaLoading;

  const formatCountdown = (totalSeconds) => {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${String(seconds).padStart(2, '0')}`;
  };

  return (
    <div className="checkout-form-list captcha-field" style={{ marginTop: '20px' }}>
      <label htmlFor={id}>
        Código de verificação <span className="required">*</span>
      </label>

      <div
        className="captcha-field__image-row"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          marginBottom: '12px',
          flexWrap: 'wrap',
        }}
      >
        <div
          className="captcha-field__image-wrap"
          style={{
            minWidth: '180px',
            minHeight: '60px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#f5f5f5',
            borderRadius: '4px',
            overflow: 'hidden',
          }}
          aria-live="polite"
        >
          {captchaLoading && (
            <span aria-label="Carregando código de verificação">
              <i className="fal fa-spinner fa-spin" aria-hidden="true" />
            </span>
          )}

          {!captchaLoading && captcha?.image && (
            <img
              src={captcha.image}
              alt="Código de verificação"
              style={{ display: 'block', maxHeight: '80px', width: 'auto' }}
            />
          )}

          {!captchaLoading && !captcha?.image && !captchaLoadError && (
            <span style={{ color: '#888', fontSize: '14px' }}>Sem imagem</span>
          )}
        </div>

        <button
          type="button"
          className="btn btn-outline-secondary"
          onClick={onRefresh}
          disabled={captchaLoading}
          aria-label="Atualizar código de verificação"
          title="Atualizar código"
        >
          {captchaLoading ? (
            <i className="fal fa-spinner fa-spin" aria-hidden="true" />
          ) : (
            <i className="icon_refresh" aria-hidden="true" />
          )}{' '}
          Atualizar código
        </button>
      </div>

      {showCountdown && (
        <p
          style={{
            marginBottom: '12px',
            fontSize: '13px',
            color: secondsLeft <= 60 ? '#c0392b' : '#666',
          }}
          aria-live="polite"
        >
          Este código expira em {formatCountdown(secondsLeft)}
          {secondsLeft <= 60 ? ' — atualize se necessário.' : '.'}
        </p>
      )}

      {secondsLeft === 0 && !captchaLoading && (
        <p style={{ marginBottom: '12px', fontSize: '13px', color: '#c0392b' }}>
          Código expirado. Gerando um novo...
        </p>
      )}

      {captchaLoadError && (
        <div style={{ marginBottom: '12px' }}>
          <p style={{ color: '#dc3545', marginBottom: '8px' }}>{captchaLoadError}</p>
          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={onRefresh}
            disabled={captchaLoading}
          >
            Tentar novamente
          </button>
        </div>
      )}

      <input
        id={id}
        name={name}
        type="text"
        value={value || ''}
        onChange={onChange}
        onBlur={onBlur}
        autoComplete="off"
        autoCapitalize="characters"
        spellCheck={false}
        disabled={captchaLoading || !captcha?.captcha_id}
        placeholder="Digite os caracteres"
        aria-invalid={Boolean(touched && error)}
        aria-describedby={touched && error ? `${id}-error` : undefined}
      />

      {touched && error && (
        <div id={`${id}-error`}>
          <ErrorMsg error={error} />
        </div>
      )}
    </div>
  );
};

export default CaptchaField;
